var React = require('react');

function Brush (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22 0H2C0.895625 0 0 0.839648 0 1.875V18.75C0 20.8213 1.79125 22.5 4 22.5H8V26.25C8 28.3213 9.79125 30 12 30C14.2087 30 16 28.3213 16 26.25V22.5H20C22.2087 22.5 24 20.8213 24 18.75V1.875C24 0.839648 23.1044 0 22 0ZM22 18.75C22 19.7836 21.1025 20.625 20 20.625H14V26.25C14 27.2836 13.1025 28.125 12 28.125C10.8975 28.125 10 27.2836 10 26.25V20.625H4C2.8975 20.625 2 19.7836 2 18.75V16.875H22V18.75ZM22 15H2V1.875H22V15Z","fill":"white"}));
}

Brush.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 30","fill":"none"};

module.exports = Brush;

Brush.default = Brush;
